import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/WorkCard.tsx");
